import React from 'react'

import { useCardContext } from '../CardProvider'
import { CardContentBadgeList } from './CardContentBadgeList'
import { CardContentBody } from './CardContentBody'
import { CardContentCardList } from './CardContentCardList'
import { CardContentHeading } from './CardContentHeading'
import { CardContentIconList } from './CardContentIconList'
import { CardContentReview } from './CardContentReview'
import { Container } from './styles'

export interface CardContentProps {
  className?: string
  children?: React.ReactNode
}

type CardContentComponent = ((props: CardContentProps) => React.ReactNode) & {
  Heading: typeof CardContentHeading
  Body: typeof CardContentBody
  Review: typeof CardContentReview
  BadgeList: typeof CardContentBadgeList
  CardList: typeof CardContentCardList
  IconList: typeof CardContentIconList
}

export const CardContent: CardContentComponent = ({
  className,
  children,
}: CardContentProps) => {
  const { layout } = useCardContext()

  return (
    <Container className={className} layout={layout}>
      {children}
    </Container>
  )
}

CardContent.Heading = CardContentHeading
CardContent.Body = CardContentBody
CardContent.Review = CardContentReview
CardContent.BadgeList = CardContentBadgeList
CardContent.CardList = CardContentCardList
CardContent.IconList = CardContentIconList
